import { render, staticRenderFns } from "./ProgressInform.vue?vue&type=template&id=353a0d5d&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353a0d5d')) {
      api.createRecord('353a0d5d', component.options)
    } else {
      api.rerender('353a0d5d', component.options)
    }
    module.hot.accept("./ProgressInform.vue?vue&type=template&id=353a0d5d&functional=true", function () {
      api.rerender('353a0d5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/tabs/ProgressInform.vue"
export default component.exports